export default __webpack_public_path__ + "static/media/IMG_1427.d8f39c9d.jpg";